import { render, staticRenderFns } from "./badgeRow.vue?vue&type=template&id=54206fb4"
import script from "./badgeRow.ts?vue&type=script&lang=ts&external"
export * from "./badgeRow.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports